/** Webpack 打包/启动时的 UTC 时间（ISO-8601） */
export const BUILD_TIME_UTC = String(process.env.VUE_APP_BUILD_TIME_UTC || '').trim()

/** Gooval Open API 基址（不含 /open/v1）。空字符串表示同源 + Functions/proxy */
export const DEFAULT_API_HOST = (() => {
  const raw = process.env.VUE_APP_DEFAULT_API_HOST
  if (raw === '') return ''
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).trim().replace(/\/$/, '')
  }
  return 'https://sp-test.gooval.io'
})()
